// Download do app Android — helpers compartilhados.
//
// O link aponta pra uma Pages Function no próprio domínio, que faz stream do
// APK do R2 (ver functions/api/download/android.js). Só oferecemos no
// NAVEGADOR: dentro do app (window.__MAPIARE_NATIVE__ === true) já é nativo,
// então escondemos.

export const APK_DOWNLOAD_URL = '/api/download/android';

/** Verdadeiro só no navegador (não dentro do app empacotado). */
export function isWebBrowser() {
  return typeof window !== 'undefined' && !window.__MAPIARE_NATIVE__;
}
